import type { IComponentController, IScope } from "angular";
import { remove } from "lodash";
import { finalize } from "rxjs/operators";

import type { IResponseWithLoading, ISite, ITeamMember } from "App/Modules/Models";
import type { ISitesRepository } from "App/Modules/Repositories";
import type { IModalService, IPageService } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services";

export default class SiteUsersListComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "irPageService", "mmModalService", "mmSitesRepository"];

    public teamMembers: IResponseWithLoading<ITeamMember[]>;

    public site: IResponseWithLoading<ISite>;

    public siteId: string;

    constructor(
        private readonly $scope: IScope,
        private readonly pageService: IPageService,
        private readonly modalService: IModalService,
        private readonly sitesRepository: ISitesRepository,
    ) {}

    public $onInit(): void {
        extendWithLoadingAndFail(this.sitesRepository.getSite(this.siteId))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (result) => {
                    this.site = result;
                },
                (result) => {
                    this.site = result;
                },
            );

        this.loadSiteUsers();
    }

    public editUser(user: ITeamMember): void {
        this.modalService.open<ITeamMember, ISite>("mmEditUserOnSite", user, this.site.data).subscribe(
            (editUserResponse) => {
                if (editUserResponse) {
                    Object.assign(user, editUserResponse);
                } else {
                    remove(this.teamMembers.data, user);
                }
            },
            (reason) => reason,
        );
    }

    public addUser(): void {
        this.modalService.open<ITeamMember, ISite>("mmAddUserToSite", null, this.site.data).subscribe(
            (addedPartnerUserResponse) => {
                this.teamMembers.data.push(addedPartnerUserResponse);
            },
            (reason) => reason,
        );
    }

    public userLabelsString(user: ITeamMember): string {
        return user.labels.length > 0 ? user.labels.map((l) => l.label).join(" | ") : undefined;
    }

    public userContractString(user: ITeamMember): string {
        const info = user.partnerUser;
        return (
            info.email +
            (info.phoneNumber ? ` | ${info.phoneNumber}` : "") +
            (info.smsNumber ? ` | ${info.smsNumber}` : "")
        );
    }

    private loadSiteUsers(): void {
        extendWithLoadingAndFail(this.sitesRepository.getUsersForSite(this.siteId))
            .pipe(finalize(() => this.$scope.$applyAsync()))
            .subscribe(
                (result) => {
                    this.teamMembers = result;
                },
                (result) => {
                    this.teamMembers = result;
                },
            );
    }
}
